import React, { useEffect, useState, useRef, createElement } from 'react';
declare global {
  interface Window {
    tf?: any;
  }
}
export const CalendlyEmbed = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const scriptRef = useRef<HTMLScriptElement | null>(null);
  useEffect(() => {
    const loadTypeform = async () => {
      try {
        if (!scriptRef.current) {
          const script = document.createElement('script');
          script.src = '//embed.typeform.com/next/embed.js';
          script.async = true;
          script.onload = () => {
            if (window.tf) {
              setIsLoading(false);
            }
          };
          script.onerror = () => {
            console.error('Failed to load Typeform widget');
            setHasError(true);
            setIsLoading(false);
          };
          scriptRef.current = script;
          document.head.appendChild(script);
        }
      } catch (error) {
        console.error('Error loading Typeform:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    loadTypeform();
    return () => {
      if (scriptRef.current && document.head.contains(scriptRef.current)) {
        document.head.removeChild(scriptRef.current);
      }
    };
  }, []);
  if (hasError) {
    return <div className="w-full max-w-6xl mx-auto mb-10 sm:mb-16" data-id="element-55">
        <div className="rounded-xl overflow-hidden shadow-lg bg-gray-900 p-8" data-id="element-56">
          <p className="text-white text-center" data-id="element-57">
            Unable to load application form. Please refresh the page or try
            again later.
          </p>
        </div>
      </div>;
  }
  return <div className="w-full max-w-6xl mx-auto mb-10 sm:mb-16" data-id="element-58">
      
    </div>;
};